import { render, staticRenderFns } from "./DwzcsqForm.vue?vue&type=template&id=5db0c375&scoped=true"
import script from "./DwzcsqForm.vue?vue&type=script&lang=js"
export * from "./DwzcsqForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db0c375",
  null
  
)

export default component.exports